/* ══════════════════════════════════════════════════════════════
   ONBOARDING V2 — Klinik Semptom-Intake Konfigürasyonu
   Tüm sorular, modüller, koşullu alanlar burada tanımlıdır.
   ══════════════════════════════════════════════════════════════ */

// ── ALAN (MODÜL) TANIMLARI ──
export const MODULES = [
  {
    id: 'hafiza',
    title: 'Hafıza ve Unutkanlık',
    description: 'Unutkanlık, kelime bulma güçlüğü, planlama zorlukları',
    questionCount: 8,
    icon: 'Brain',
    color: '#A78BFA',
    domain: 'hafiza',
  },
  {
    id: 'dikkat',
    title: 'Dikkat ve Odaklanma',
    description: 'Dikkat dağınıklığı, odaklanma güçlüğü, zihinsel bulanıklık',
    questionCount: 6,
    icon: 'Focus',
    color: '#F59E0B',
    domain: 'dikkat',
  },
  {
    id: 'kaygi',
    title: 'Kaygı, Stres ve Panik',
    description: 'Gerginlik, endişe, panik atak, bedensel kaygı belirtileri',
    questionCount: 8,
    icon: 'AlertTriangle',
    color: '#EF4444',
    domain: 'kaygi',
  },
  {
    id: 'ruh_hali',
    title: 'Ruh Hali ve Duygusal Durum',
    description: 'Mutsuzluk, ilgi kaybı, enerji düşüklüğü, değersizlik',
    questionCount: 7,
    icon: 'Heart',
    color: '#EC4899',
    domain: 'ruh_hali',
  },
  {
    id: 'uyku',
    title: 'Uyku',
    description: 'Uykuya dalma, gece uyanma, yorgunluk, horlama',
    questionCount: 8,
    icon: 'Moon',
    color: '#38BDF8',
    domain: 'uyku',
  },
  {
    id: 'kalp',
    title: 'Kalp ve Dolaşım',
    description: 'Tansiyon, göğüs ağrısı, çarpıntı, nefes darlığı, şişlik',
    questionCount: 10,
    icon: 'Activity',
    color: '#F97316',
    domain: 'kalp_dolasim',
  },
  {
    id: 'norolojik',
    title: 'Nörolojik Belirtiler',
    description: 'Baş ağrısı, baş dönmesi, uyuşma, güçsüzlük, nöbet',
    questionCount: 8,
    icon: 'Zap',
    color: '#8B5CF6',
    domain: 'norolojik',
  },
  {
    id: 'genel',
    title: 'Genel Sağlık ve Tüm Alanlar',
    description: 'Kapsamlı değerlendirme — tüm modüller dahil',
    questionCount: null, // dynamic
    icon: 'Shield',
    color: '#22D3EE',
    domain: 'genel',
  },
];

// ── 4'LÜ SIKLIK SEÇENEKLERİ (çoğu modülde ortak) ──
export const FREQ_4 = [
  { value: 'hayir', label: 'Hayır' },
  { value: 'nadiren', label: 'Nadiren' },
  { value: 'bazen', label: 'Bazen' },
  { value: 'sik', label: 'Sık sık' },
];

// ── ORTAK TEMEL SORULAR (B bölümü) ──
export const COMMON_QUESTIONS = [
  {
    id: 'dogum_yili',
    text: 'Doğum yılınız nedir?',
    type: 'single',
    options: Array.from({ length: 91 }, (_, i) => {
      const y = 2010 - i;
      return { value: String(y), label: String(y) };
    }),
  },
  {
    id: 'cinsiyet',
    text: 'Cinsiyet',
    type: 'single',
    options: [
      { value: 'kadin', label: 'Kadın' },
      { value: 'erkek', label: 'Erkek' },
      { value: 'belirtmek_istemiyor', label: 'Belirtmek istemiyorum' },
    ],
  },
  {
    id: 'egitim',
    text: 'Eğitim düzeyiniz',
    type: 'single',
    options: [
      { value: 'ilkokul', label: 'İlkokul' },
      { value: 'ortaokul', label: 'Ortaokul' },
      { value: 'lise', label: 'Lise' },
      { value: 'universite', label: 'Üniversite' },
      { value: 'yuksek_lisans', label: 'Yüksek lisans / Doktora' },
    ],
  },
  {
    id: 'boy',
    text: 'Boyunuz (cm)',
    type: 'single',
    options: Array.from({ length: 81 }, (_, i) => {
      const v = 140 + i;
      return { value: String(v), label: `${v} cm` };
    }),
  },
  {
    id: 'kilo',
    text: 'Kilonuz (kg)',
    type: 'single',
    options: Array.from({ length: 141 }, (_, i) => {
      const v = 35 + i;
      return { value: String(v), label: `${v} kg` };
    }),
  },
  {
    id: 'sure',
    text: 'Şu an sizi en çok zorlayan durum ne zamandır devam ediyor?',
    type: 'single',
    options: [
      { value: 'birkac_gun', label: 'Son birkaç gün' },
      { value: 'birkac_hafta', label: 'Son birkaç hafta' },
      { value: '1_3_ay', label: 'Son 1-3 ay' },
      { value: '3_ay_uzun', label: '3 aydan uzun' },
    ],
  },
  {
    id: 'sure_detay',
    text: 'Yaşadığınız sorunu kısaca anlatır mısınız?',
    type: 'text',
    placeholder: 'Örneğin: Son 2 aydır uyuyamıyorum, sürekli kaygılıyım...',
    multiline: true,
  },
  {
    id: 'etki',
    text: 'Bu durum günlük yaşamınızı ne kadar etkiliyor?',
    type: 'single',
    options: [
      { value: 'cok_az', label: 'Çok az' },
      { value: 'biraz', label: 'Biraz' },
      { value: 'belirgin', label: 'Belirgin' },
      { value: 'ciddi', label: 'Ciddi düzeyde' },
    ],
  },
  {
    id: 'ilac_kullanimi',
    text: 'Düzenli ilaç kullanıyor musunuz?',
    type: 'yesno',
    followups: [
      {
        id: 'ilac_listesi',
        text: 'Hangi ilaçları kullanıyorsunuz?',
        type: 'textarea',
        showWhen: true,
      },
      {
        id: 'ilac_siklik',
        text: 'Ne sıklıkla kullanıyorsunuz?',
        type: 'single',
        showWhen: true,
        options: [
          { value: 'gunde_1', label: 'Günde 1 kez' },
          { value: 'gunde_2', label: 'Günde 2 kez' },
          { value: 'gunde_3_fazla', label: 'Günde 3 veya daha fazla' },
          { value: 'haftalik', label: 'Haftalık' },
          { value: 'gerektiginde', label: 'Gerektiğinde' },
        ],
      },
      {
        id: 'ilac_aksatma',
        text: 'Son zamanlarda ilaç aksattığınız oldu mu?',
        type: 'yesno',
        showWhen: true,
        followups: [
          {
            id: 'ilac_aksatma_not',
            text: 'Kısaca belirtmek ister misiniz?',
            type: 'text',
            showWhen: true,
          },
        ],
      },
    ],
  },
  {
    id: 'kronik_hastalik',
    text: 'Daha önce size tanı konmuş kronik bir hastalık var mı?',
    type: 'yesno',
    followups: [
      {
        id: 'kronik_hastalik_detay',
        text: 'Kısaca yazınız',
        type: 'textarea',
        showWhen: true,
      },
    ],
  },
];

// ── ACİL DURUM / KIRMIZI BAYRAK SORULARI (C bölümü) ──
export const RED_FLAG_QUESTIONS = [
  { id: 'rf_yuz_guc', text: 'Ani başlayan yüz, kol veya bacakta güçsüzlük ya da uyuşma oldu mu?' },
  { id: 'rf_konusma', text: 'Ani konuşma bozulması veya söyleneni anlamada güçlük oldu mu?' },
  { id: 'rf_gorme', text: 'Ani görme kaybı veya çift görme oldu mu?' },
  { id: 'rf_denge', text: 'Ani başlayan belirgin denge kaybı oldu mu?' },
  { id: 'rf_bas_agrisi', text: 'Hayatınızın en şiddetli, ani başlayan baş ağrısı oldu mu?' },
  { id: 'rf_gogus', text: 'Şu anda veya son saatlerde şiddetli göğüs baskısı yaşıyor musunuz?' },
  { id: 'rf_nefes', text: 'Nefes almakta ciddi zorlanıyor musunuz?' },
  { id: 'rf_bayilma', text: 'Bayıldınız mı veya bayılacak gibi oldunuz mu?' },
  { id: 'rf_zarar', text: 'Kendinize zarar verme düşünceniz oldu mu?' },
  { id: 'rf_anlamsiz', text: 'Yaşamın anlamsız geldiği ve kendinizi güvende hissetmediğiniz anlar oldu mu?' },
];

// ── MODÜL SORULARI ──

export const MODULE_QUESTIONS = {
  hafiza: [
    { id: 'h1', text: 'Son zamanlarda yeni öğrendiğiniz bilgileri unutmanız arttı mı?', type: 'freq4' },
    { id: 'h2', text: 'Aynı soruyu veya aynı konuyu tekrar ettiğiniz oluyor mu?', type: 'freq4' },
    { id: 'h3', text: 'Kelime bulmakta zorlandığınız oluyor mu?', type: 'freq4' },
    { id: 'h4', text: 'Randevu, etkinlik veya planları unutuyor musunuz?', type: 'freq4' },
    { id: 'h5', text: 'Eşyalarınızı sık kaybediyor musunuz?', type: 'freq4' },
    { id: 'h6', text: 'Tanıdık yerlerde yönünüzü karıştırdığınız oluyor mu?', type: 'freq4' },
    { id: 'h7', text: 'Günlük işleri planlamak veya sıraya koymak zorlaştı mı?', type: 'freq4' },
    {
      id: 'h8', text: 'Yakınlarınız sizde unutkanlık veya belirgin bir değişim fark etti mi?', type: 'freq4',
      conditionalNote: { trigger: ['bazen', 'sik'], id: 'h8_not', text: 'Yakınlarınız en çok hangi değişimi fark etti?' },
    },
    {
      id: 'h9', text: 'Bu durum günlük hayatınızı etkiliyor mu?', type: 'yesno',
      dedupeKey: 'gunluk_etki',
      followups: [{
        id: 'h9a', text: 'En çok hangi alan etkileniyor?', type: 'single', showWhen: true,
        options: [
          { value: 'is_okul', label: 'İş / okul' },
          { value: 'ev_isleri', label: 'Ev işleri' },
          { value: 'sosyal', label: 'Sosyal yaşam' },
          { value: 'gunluk_unutkanlik', label: 'Günlük unutkanlık' },
          { value: 'planlama', label: 'Planlama / organizasyon' },
        ],
      }],
    },
  ],

  dikkat: [
    { id: 'd1', text: 'Dikkatiniz kolay dağılır mı?', type: 'freq4' },
    { id: 'd2', text: 'Bir işe başladıktan sonra sürdürmekte zorlanır mısınız?', type: 'freq4' },
    { id: 'd3', text: 'Aynı anda birden fazla işi yönetmekte zorlanır mısınız?', type: 'freq4' },
    { id: 'd4', text: 'Okurken veya dinlerken zihniniz sık sık başka yere kayar mı?', type: 'freq4' },
    { id: 'd5', text: 'Günlük işlerinizi bitirmekte gecikme yaşıyor musunuz?', type: 'freq4' },
    { id: 'd6', text: 'Zihinsel olarak "bulanık" veya dağınık hissettiğiniz olur mu?', type: 'freq4' },
    {
      id: 'd7', text: 'Bu durum iş, okul veya ev yaşamınızı etkiliyor mu?', type: 'yesno',
      dedupeKey: 'gunluk_etki',
      followups: [{
        id: 'd7a', text: 'En çok hangi alanda zorlanıyorsunuz?', type: 'text', showWhen: true,
      }],
    },
  ],

  kaygi: [
    { id: 'k1', text: 'Kendinizi sık sık gergin veya huzursuz hissediyor musunuz?', type: 'freq4' },
    { id: 'k2', text: 'Günlük konular hakkında aşırı endişelendiğiniz oluyor mu?', type: 'freq4' },
    { id: 'k3', text: 'Endişelerinizi kontrol etmekte zorlandığınız oluyor mu?', type: 'freq4' },
    { id: 'k4', text: 'Bedensel olarak gerginlik, sıkışma veya kasılma hissediyor musunuz?', type: 'freq4' },
    { id: 'k5', text: 'Kaygı nedeniyle dikkatinizin dağıldığı oluyor mu?', type: 'freq4' },
    { id: 'k6', text: 'Kaygı nedeniyle uykuya dalmakta veya uykuyu sürdürmekte zorlanıyor musunuz?', type: 'freq4' },
    { id: 'k7', text: 'Kaygı nedeniyle kalp çarpıntısı, nefes darlığı veya mide sıkıntısı yaşıyor musunuz?', type: 'freq4' },
    {
      id: 'k8', text: 'Panik atak benzeri ani yoğun korku veya bedensel boşalma yaşadınız mı?', type: 'freq4',
      conditionalNote: {
        trigger: ['bazen', 'sik'],
        fields: [
          { id: 'k8a', text: 'Atak sırasında en çok ne hissediyorsunuz?', type: 'textarea' },
          { id: 'k8b', text: 'Ne sıklıkla oluyor?', type: 'single', options: [
            { value: 'ayda_birkac', label: 'Ayda birkaç kez' },
            { value: 'haftada_birkac', label: 'Haftada birkaç kez' },
            { value: 'haftada_1_fazla', label: 'Haftada 1 veya daha fazla' },
            { value: 'duzensiz', label: 'Düzensiz' },
          ]},
        ],
      },
    },
  ],

  ruh_hali: [
    { id: 'r1', text: 'Son zamanlarda kendinizi mutsuz veya çökkün hissediyor musunuz?', type: 'freq4' },
    { id: 'r2', text: 'Eskiden keyif aldığınız şeylere ilginiz azaldı mı?', type: 'freq4' },
    { id: 'r3', text: 'Enerjinizin düştüğünü veya isteksizlik yaşadığınızı hissediyor musunuz?', type: 'freq4' },
    { id: 'r4', text: 'Kendinizi değersiz, yetersiz veya suçlu hissettiğiniz oluyor mu?', type: 'freq4' },
    { id: 'r5', text: 'Sosyal olarak geri çekildiğiniz oluyor mu?', type: 'freq4' },
    { id: 'r6', text: 'Karar vermekte zorlanıyor musunuz?', type: 'freq4' },
    { id: 'r7', text: 'Sabahları güne başlamakta zorlanıyor musunuz?', type: 'freq4' },
    {
      id: 'r8', text: 'Bu durum günlük yaşamınızı belirgin etkiliyor mu?', type: 'yesno',
      dedupeKey: 'gunluk_etki',
      followups: [{
        id: 'r8a', text: 'En çok hangi alanda etkiliyor?', type: 'single', showWhen: true,
        options: [
          { value: 'is_okul', label: 'İş / okul' },
          { value: 'ev_yasami', label: 'Ev yaşamı' },
          { value: 'sosyal', label: 'Sosyal ilişkiler' },
          { value: 'kendime_bakim', label: 'Kendime bakım' },
          { value: 'genel_kalite', label: 'Genel yaşam kalitesi' },
        ],
      }],
    },
  ],

  uyku: [
    { id: 'u1', text: 'Uykuya dalmakta zorlanıyor musunuz?', type: 'freq4' },
    { id: 'u2', text: 'Gece sık uyanıyor musunuz?', type: 'freq4' },
    { id: 'u3', text: 'Sabah erken uyanıp tekrar uyumakta zorlanıyor musunuz?', type: 'freq4' },
    { id: 'u4', text: 'Sabah dinlenmeden kalkıyor musunuz?', type: 'freq4' },
    { id: 'u5', text: 'Gün içinde belirgin uyku hali veya yorgunluk yaşıyor musunuz?', type: 'freq4' },
    {
      id: 'u6', text: 'Ortalama kaç saat uyuyorsunuz?', type: 'single',
      options: [
        { value: '5_az', label: '5 saatten az' },
        { value: '5_6', label: '5\u20136 saat' },
        { value: '6_7', label: '6\u20137 saat' },
        { value: '7_8', label: '7\u20138 saat' },
        { value: '8_fazla', label: '8 saatten fazla' },
      ],
    },
    {
      id: 'u7', text: 'Horladığınız söylendi mi?', type: 'yesno',
      followups: [{
        id: 'u7a', text: 'Bunu kim fark etti?', type: 'single', showWhen: true,
        options: [
          { value: 'kendim', label: 'Kendim' },
          { value: 'yakinim', label: 'Yakınım' },
          { value: 'ikisi', label: 'İkisi de' },
        ],
      }],
    },
    {
      id: 'u8', text: 'Uykuda nefesinizin durduğu veya nefes nefese kaldığınız söylendi mi?', type: 'yesno',
      followups: [{
        id: 'u8a', text: 'Kısaca açıklamak ister misiniz?', type: 'text', showWhen: true,
      }],
    },
  ],

  kalp: [
    {
      id: 'kd1', text: 'Daha önce yüksek tansiyon tanısı aldınız mı?', type: 'yesno',
      followups: [{ id: 'kd1a', text: 'Düzenli takip veya ilaç kullanıyor musunuz?', type: 'yesno', showWhen: true }],
    },
    {
      id: 'kd2', text: 'Evde tansiyon ölçüyor musunuz?', type: 'yesno',
      followups: [{ id: 'kd2a', text: 'Son ölçümünüzü biliyor musunuz?', type: 'text', showWhen: true, placeholder: 'örn. 135/85' }],
    },
    {
      id: 'kd3', text: 'Göğsünüzde baskı, sıkışma veya ağrı hissi oluyor mu?', type: 'yesno',
      followups: [
        {
          id: 'kd3a', text: 'En çok ne zaman oluyor?', type: 'single', showWhen: true,
          options: [
            { value: 'eforla', label: 'Eforla' },
            { value: 'dinlenirken', label: 'Dinlenirken' },
            { value: 'rastgele', label: 'Rastgele' },
            { value: 'emin_degil', label: 'Emin değilim' },
          ],
        },
        {
          id: 'kd3b', text: 'Yayılım oluyor mu?', type: 'yesno', showWhen: true,
          followups: [{
            id: 'kd3c', text: 'Nereye yayılıyor?', type: 'single', showWhen: true,
            options: [
              { value: 'sol_kol', label: 'Sol kol' },
              { value: 'iki_kol', label: 'Her iki kol' },
              { value: 'boyun_cene', label: 'Boyun / çene' },
              { value: 'sirt', label: 'Sırt' },
              { value: 'karin', label: 'Karın / mide' },
              { value: 'emin_degil', label: 'Emin değilim' },
            ],
          }],
        },
      ],
    },
    {
      id: 'kd4', text: 'Çarpıntı veya düzensiz atım hissediyor musunuz?', type: 'yesno',
      followups: [
        {
          id: 'kd4a', text: 'Ne sıklıkla?', type: 'single', showWhen: true,
          options: [
            { value: 'nadiren', label: 'Nadiren' },
            { value: 'haftada_birkac', label: 'Haftada birkaç kez' },
            { value: 'sik', label: 'Sık' },
          ],
        },
        { id: 'kd4b', text: 'Baş dönmesi veya nefes darlığı eşlik ediyor mu?', type: 'yesno', showWhen: true },
      ],
    },
    { id: 'kd5', text: 'Eforla nefes darlığı yaşıyor musunuz?', type: 'yesno' },
    { id: 'kd6', text: 'Düz yatınca nefes darlığınız artıyor mu?', type: 'yesno' },
    { id: 'kd7', text: 'Gece nefes darlığı ile uyandığınız oluyor mu?', type: 'yesno' },
    { id: 'kd8', text: 'Ayak veya bacaklarda şişlik oluyor mu?', type: 'yesno' },
    {
      id: 'kd9', text: 'Son günlerde hızlı kilo artışı fark ettiniz mi?', type: 'yesno',
      followups: [{ id: 'kd9a', text: 'Yaklaşık ne kadar?', type: 'text', showWhen: true }],
    },
    {
      id: 'kd10', text: 'Daha önce kalp hastalığı, stent, ritim bozukluğu veya kalp yetersizliği tanısı aldınız mı?', type: 'yesno',
      followups: [{ id: 'kd10a', text: 'Kısaca yazınız', type: 'textarea', showWhen: true }],
    },
  ],

  norolojik: [
    {
      id: 'n1', text: 'Sık baş ağrısı yaşıyor musunuz?', type: 'yesno',
      followups: [{
        id: 'n1a', text: 'En çok nasıl oluyor?', type: 'single', showWhen: true,
        options: [
          { value: 'hafif_sik', label: 'Hafif ama sık' },
          { value: 'zonklayici', label: 'Zonklayıcı' },
          { value: 'ani_siddetli', label: 'Ani ve çok şiddetli' },
          { value: 'emin_degil', label: 'Emin değilim' },
        ],
      }],
    },
    { id: 'n2', text: 'Baş dönmesi veya dengesizlik oluyor mu?', type: 'yesno' },
    { id: 'n3', text: 'Kol, bacak veya yüzde uyuşma hissediyor musunuz?', type: 'yesno' },
    { id: 'n4', text: 'Kol, bacak veya yüzde güçsüzlük hissediyor musunuz?', type: 'yesno' },
    { id: 'n5', text: 'Konuşurken kelimeleri çıkarmakta veya toparlamakta zorlandığınız oluyor mu?', type: 'yesno' },
    { id: 'n6', text: 'Görmede bulanıklık, kayıp veya değişiklik yaşıyor musunuz?', type: 'yesno' },
    {
      id: 'n7', text: 'Bayılma, dalma veya nöbet benzeri durumlar yaşadınız mı?', type: 'yesno',
      followups: [{ id: 'n7a', text: 'Kısaca anlatır mısınız?', type: 'text', showWhen: true }],
    },
    {
      id: 'n8', text: 'Daha önce ciddi kafa travması veya düşme yaşadınız mı?', type: 'yesno',
      followups: [{ id: 'n8a', text: 'Kısaca belirtin', type: 'text', showWhen: true }],
    },
  ],
};

// ── DEDUPLİKASYON: Ortak "günlük etki" sorusu birden fazla modülde var ──
// h9 (hafıza), d7 (dikkat), r8 (ruh_hali) aynı dedupeKey'e sahip.
// İlk karşılaşılan gösterilir, diğerleri atlanır. Cevap tüm modüllere yazılır.

// ── DOMAIN → SORU ID MAPPING (backend scoring için) ──
export const DOMAIN_QUESTION_MAP = {
  hafiza: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7', 'h8', 'h9'],
  dikkat: ['d1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7'],
  kaygi: ['k1', 'k2', 'k3', 'k4', 'k5', 'k6', 'k7', 'k8'],
  ruh_hali: ['r1', 'r2', 'r3', 'r4', 'r5', 'r6', 'r7', 'r8'],
  uyku: ['u1', 'u2', 'u3', 'u4', 'u5', 'u6', 'u7', 'u8'],
  kalp_dolasim: ['kd1', 'kd2', 'kd3', 'kd4', 'kd5', 'kd6', 'kd7', 'kd8', 'kd9', 'kd10'],
  norolojik: ['n1', 'n2', 'n3', 'n4', 'n5', 'n6', 'n7', 'n8'],
};

// ── Toplam soru sayısı hesaplama (dedupe dahil) ──
export function calcTotalQuestions(selectedModuleIds) {
  const COMMON_COUNT = 10; // B bölümü (sure_detay dahil)
  const RED_FLAG_COUNT = 10; // C bölümü
  const seenDedupe = new Set();
  let moduleTotal = 0;

  const mods = selectedModuleIds.includes('genel')
    ? ['hafiza', 'dikkat', 'kaygi', 'ruh_hali', 'uyku', 'kalp', 'norolojik']
    : selectedModuleIds;

  for (const modId of mods) {
    const questions = MODULE_QUESTIONS[modId] || [];
    for (const q of questions) {
      if (q.dedupeKey) {
        if (seenDedupe.has(q.dedupeKey)) continue;
        seenDedupe.add(q.dedupeKey);
      }
      moduleTotal++;
    }
  }

  return COMMON_COUNT + RED_FLAG_COUNT + moduleTotal;
}

// ── Modül sorularını birleştir (dedupe ile) ──
export function buildModuleQuestions(selectedModuleIds) {
  const mods = selectedModuleIds.includes('genel')
    ? ['hafiza', 'dikkat', 'kaygi', 'ruh_hali', 'uyku', 'kalp', 'norolojik']
    : selectedModuleIds;

  const seenDedupe = new Set();
  const result = [];

  for (const modId of mods) {
    const questions = MODULE_QUESTIONS[modId] || [];
    const modQuestions = [];
    for (const q of questions) {
      if (q.dedupeKey) {
        if (seenDedupe.has(q.dedupeKey)) continue;
        seenDedupe.add(q.dedupeKey);
      }
      modQuestions.push({ ...q, module: modId });
    }
    if (modQuestions.length > 0) {
      const mod = MODULES.find(m => m.id === modId);
      result.push({ moduleId: modId, title: mod?.title || modId, color: mod?.color || '#67E8F9', questions: modQuestions });
    }
  }

  return result;
}
